import { SEOHead } from "@/components/SEOHead";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { ArrowRight, ShieldCheck, FileText, Shield, Fuel, DollarSign, Users, Monitor, Megaphone, CheckCircle2 } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

const getServicesData = (isRu: boolean) => [
  {
    id: "insurance",
    title: isRu ? "Страхование" : "Insurance",
    heading: isRu ? "Услуги страхования" : "INSURANCE Services",
    subheading: isRu ? "Зачем рисковать?" : "Why risk it?",
    desc: isRu ? "Наши услуги по страхованию обеспечивают надежное покрытие, защищая вас и ваши активы, давая уверенность без лишних затрат." : "Our insurance services provide reliable coverage that protects you and your assets, giving you peace of mind without breaking the bank.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/truck-insurance",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "safety",
    title: isRu ? "Безопасность и комплаенс" : "Safety & Compliance",
    heading: isRu ? "Безопасность и комплаенс" : "Safety & Compliance",
    subheading: isRu ? "Мы вас прикроем!" : "We've got you covered!",
    desc: isRu ? "Наши услуги по безопасности и комплаенсу гарантируют, что ваш бизнес соответствует всем нормам." : "Our safety and compliance services ensure your business meets all regulations, so you can focus on what you do best while we handle the rest.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/safety-compliance",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "permits",
    title: isRu ? "Разрешения и лицензии" : "Permits & Licensing",
    heading: isRu ? "Разрешения и лицензии" : "Permits & Licensing",
    subheading: isRu ? "Не беспокойтесь о комплаенсе – мы позаботимся об этом." : "Don’t stress about compliance – we’ve got it.",
    desc: isRu ? "Наши услуги по разрешениям и лицензиям упрощают комплаенс, позволяя вам сосредоточиться на бизнесе." : "Our permits and licensing services make compliance easy, letting you focus on your business.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/permitsandlicensing",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "tms",
    title: "TMS",
    heading: isRu ? "Услуги TMS" : "TMS Services",
    subheading: isRu ? "Оптимизируйте маршруты без усилий." : "Optimize your routes effortlessly with our TMS services.",
    desc: isRu ? "Наши решения TMS упрощают логистику, снижают затраты и повышают эффективность." : "Our TMS solutions simplify logistics, cut costs, and boost efficiency—giving you more control over your trucking operations.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/tms",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "fuel",
    title: isRu ? "Топливные карты" : "Fuel Cards",
    heading: isRu ? "ТОПЛИВНЫЕ КАРТЫ" : "FUEL CARDS",
    subheading: isRu ? "Заправляйтесь умнее, экономьте больше." : "Fuel smarter, save more.",
    desc: isRu ? "Наши топливные карты предлагают скидки и контроль над расходами." : "Our fuel card services offer discounts and control over expenses, helping you cut costs and keep your fleet moving efficiently.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/fuel-cards",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "accounting",
    title: isRu ? "Бухгалтерия и факторинг" : "Accounting & Factoring",
    heading: isRu ? "Бухгалтерия и факторинг" : "Accounting & Factoring",
    subheading: isRu ? "Оставайтесь при деньгах, без стресса." : "Stay cash flow ready, stress-free.",
    desc: isRu ? "Наши услуги по бухгалтерии и факторингу гарантируют, что вы получите оплату быстрее." : "Our accounting and factoring services ensure you get paid faster and manage finances smoothly, keeping your business financially strong.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/factoring",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "brokerage",
    title: isRu ? "Брокеридж" : "Brokerage",
    heading: isRu ? "Брокеридж" : "Brokerage",
    subheading: isRu ? "Расширяйте свои возможности с легкостью!" : "Expand your reach with ease!",
    desc: isRu ? "Наши брокерские услуги связывают вас с надежными перевозчиками и оптимизируют логистику." : "Our brokerage services connect you with reliable carriers and streamline logistics, helping you move freight efficiently and grow your business.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/brokerage",
    btn2: isRu ? "Бесплатная консультация" : "Get a Free Quote",
    btn2Link: "/free-consultation",
  },
  {
    id: "hr",
    title: isRu ? "HR и рекрутинг" : "HR & Recruiting",
    heading: isRu ? "HR и рекрутинг" : "HR & Recruiting",
    subheading: isRu ? "Создайте сильную команду без усилий." : "Build a strong team effortlessly.",
    desc: isRu ? "Наши услуги по HR и рекрутингу найдут подходящие таланты для вашего бизнеса." : "Our HR & recruiting services find the right talent for your business, saving you time and ensuring a workforce you can count on.",
    btn1: isRu ? "Узнать больше" : "Learn More",
    btn1Link: "/hr-recruiting",
    btn2: isRu ? "Нанять водителя сейчас!" : "Recruit your driver now!",
    btn2Link: "/free-consultation",
  },
];

const getBannersData = (isRu: boolean) => [
  {
    label: isRu ? "Эксклюзивное предложение" : "Exclusive Offer",
    title: isRu ? "ТОПЛИВНЫЕ КАРТЫ" : "FUEL CARDS",
    desc: isRu ? "Заправляйтесь умнее, экономьте больше на каждой миле с нашими топливными картами." : "Fuel smarter, save more on every mile with our premium fuel cards.",
    btn: isRu ? "Узнать больше" : "Learn More",
    img: "https://vibe.filesafe.space/1777392978847194987/assets/eb8ee3aa-631a-4271-9ab5-0652cd7aa6c3.png",
    link: "/fuel-cards",
    accent: "border-primary/50"
  },
  {
    label: isRu ? "Быстрый процесс" : "Quick Process",
    title: isRu ? "ПОКУПКА/ПРОДАЖА MC" : "MC BUY/SALE",
    desc: isRu ? "Упростите передачу полномочий MC с нашей командой экспертов." : "Streamline your MC authority transfer with our expert team.",
    btn: isRu ? "Заполнить форму" : "Fill The Form",
    img: "https://vibe.filesafe.space/1777392978847194987/assets/1f78442e-87c7-406a-a772-2ee7cb683a7c.png",
    link: "/free-consultation",
    accent: "border-white/30"
  },
  {
    label: isRu ? "Управление автопарком" : "Fleet Management",
    title: isRu ? "ПОКУПКА/ПРОДАЖА ТРАКОВ" : "TRUCK BUY/SALE",
    desc: isRu ? "Расширьте или обновите свой автопарк с помощью нашей надежной площадки." : "Expand or upgrade your fleet with our trusted marketplace.",
    btn: isRu ? "Заполнить форму" : "Fill The Form",
    img: "https://vibe.filesafe.space/1777392978847194987/assets/f9b1a150-b40a-449d-8557-57466ce209f1.png",
    link: "/free-consultation",
    accent: "border-white/30"
  }
];

const serviceIcons = [Shield, ShieldCheck, FileText, Monitor, Fuel, DollarSign, Megaphone, Users];

const serviceSchema = {

  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Trucking Services",
  "provider": {
    "@type": "LocalBusiness",
    "name": "AITIM Group"
  },
  "areaServed": "US",
  "description": "Comprehensive trucking services including insurance, safety compliance, permits, TMS, fuel cards, accounting, brokerage, and HR recruiting."
};

const Trucking = () => {
  const { t, language } = useLanguage();
  const isRu = language === 'ru';
  const servicesData = getServicesData(isRu);
  const [activeService, setActiveService] = useState(0);
  const [displayService, setDisplayService] = useState(0);
  const [animating, setAnimating] = useState(false);
  const active = servicesData[displayService];
  const ActiveIcon = serviceIcons[displayService];
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      if (!sectionRef.current) return;
      const cards = sectionRef.current.querySelectorAll('.group');
      cards.forEach((card) => {
        const rect = (card as HTMLElement).getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        (card as HTMLElement).style.setProperty('--mouse-x', `${x}%`);
        (card as HTMLElement).style.setProperty('--mouse-y', `${y}%`);
      });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const handleServiceChange = (i: number) => {
    if (i === activeService || animating) return;
    setAnimating(true);
    setActiveService(i);
    setTimeout(() => {
      setDisplayService(i);
      setAnimating(false);
    }, 280);
  };

  return (
    <div className="min-h-screen bg-background font-sans">
      <SEOHead 
        title="Empowering Your Road to Growth | Trucking"
        description="Empowering Your Road to Growth"
        canonical="/trucking"
        schemaJson={serviceSchema}
      />
      <Navbar />
      
      <main>
        {/* Hero Section */}
        <section className="relative pt-28 pb-16 lg:pt-48 lg:pb-32 overflow-hidden bg-navy-950">
          <div className="absolute inset-0 z-0 bg-navy-950">
            <img 
              src="https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp" 
              srcSet="https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp?w=480 480w, https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp?w=768 768w, https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp?w=1200 1200w"
              sizes="(max-width: 768px) 100vw, 1200px"
              alt="Trucking" 
              fetchPriority="high"
              width={1024}
              height={768}
              className="w-full h-full object-cover object-center opacity-40"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/80 to-transparent"></div>
          </div>

          <div className="container mx-auto px-4 relative z-10 text-center">
            <div className="max-w-4xl mx-auto">
              <div className="inline-block px-4 py-1.5 rounded-full bg-primary/20 text-primary font-semibold text-sm mb-6 border border-primary/30 tracking-wide uppercase">
                {isRu ? "Услуги для Траков" : "Trucking"}
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-7xl font-bold text-white mb-8 leading-tight tracking-tight">
                {isRu ? "Развиваем Ваш" : "Empowering Your"} <span className="text-primary">{isRu ? "Путь к Росту" : "Road to Growth"}</span>
              </h1>
              <Link to="/free-consultation">
                <Button size="lg" className="bg-primary hover:bg-primary/90 text-white rounded-sm px-8 h-14 text-lg">
                  {isRu ? "Связаться с нами" : "Get In Touch"} <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Services Interactive Section */}
        <section className="py-24 bg-slate-50 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center mb-16">
              <div className="text-primary font-bold tracking-widest uppercase text-xs mb-4">{isRu ? "Наш Опыт" : "Our Expertise"}</div>
              <h2 className="text-3xl md:text-5xl font-extrabold text-navy-950">
                {isRu ? "Комплексные" : "Comprehensive"} <span className="text-primary">{isRu ? "Услуги" : "Services"}</span>
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-[300px_1fr] gap-6 max-w-6xl mx-auto">
              {/* Left: vertical nav pills */}
              <div className="grid grid-cols-2 md:grid-cols-3 lg:flex lg:flex-col gap-2 lg:gap-2 pb-2 lg:pb-0">
                {servicesData.map((service, i) => {
                  const NavIcon = serviceIcons[i];
                  const isActive = activeService === i;
                  return (
                    <button
                      key={service.id}
                      onClick={() => handleServiceChange(i)}
                      className={`group flex items-center gap-2 lg:gap-3 px-3 py-3 lg:px-5 lg:py-4 rounded-2xl text-left transition-all duration-300 border ${
                        isActive
                          ? "bg-primary text-primary-foreground border-primary shadow-lg shadow-primary/20 scale-[1.02]"
                          : "bg-white text-slate-600 border-slate-200 hover:border-primary/30 hover:bg-primary/5 hover:text-navy-950"
                      }`}
                    >
                      <div className={`w-8 h-8 lg:w-9 lg:h-9 rounded-xl flex items-center justify-center shrink-0 transition-all duration-300 ${
                        isActive ? "bg-white/20" : "bg-slate-100 group-hover:bg-primary/10"
                      }`}>
                        <NavIcon className={`w-4 h-4 lg:w-5 lg:h-5 transition-colors duration-300 ${isActive ? "text-primary-foreground" : "text-primary"}`} strokeWidth={1.8} />
                      </div>
                      <span className="font-semibold text-[11px] sm:text-xs lg:text-sm leading-tight">{service.title}</span>
                      {isActive && <ArrowRight className="ml-auto w-4 h-4 opacity-70 hidden lg:block" />}
                    </button>
                  );
                })}
              </div>

              {/* Right: animated content panel */}
              <div
                className="bg-white rounded-3xl border border-slate-100 shadow-xl overflow-hidden transition-all duration-300"
                style={{
                  opacity: animating ? 0 : 1,
                  transform: animating ? "translateY(16px) scale(0.98)" : "translateY(0) scale(1)",
                  transition: "opacity 0.28s cubic-bezier(0.4,0,0.2,1), transform 0.28s cubic-bezier(0.4,0,0.2,1)",
                }}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 h-full">
                  {/* Content */}
                  <div className="p-8 md:p-12 flex flex-col justify-between">
                    <div>
                      <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mb-8">
                        <ActiveIcon className="w-7 h-7 text-primary" strokeWidth={1.8} />
                      </div>
                      <div className="text-primary font-bold tracking-widest uppercase text-xs mb-3">{active.title}</div>
                      <h3 className="text-3xl md:text-4xl font-black text-navy-950 leading-tight mb-4">{active.subheading}</h3>
                      <p className="text-slate-500 leading-relaxed text-base mb-8">{active.desc}</p>
                    </div>
                    <div className="flex flex-wrap gap-3">
                      <Link to={active.btn1Link || "/free-consultation"} aria-label={`${active.btn1} ${active.title}`}>
                        <Button className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl px-6 h-12 font-semibold">
                          {active.btn1} <span className="sr-only"> {active.title}</span> <ArrowRight className="ml-2 w-4 h-4" />
                        </Button>
                      </Link>
                      <Link to={active.btn2Link || "/free-consultation"}>
                        <Button variant="outline" className="border-slate-200 text-navy-950 hover:bg-slate-50 hover:text-primary rounded-xl px-6 h-12 font-semibold bg-white whitespace-normal text-left leading-tight max-w-[200px]">
                          {active.btn2}
                        </Button>
                      </Link>
                    </div>
                  </div>

                  {/* Visual panel */}
                  <div className="bg-gradient-to-br from-primary/5 via-primary/10 to-primary/5 flex items-center justify-center p-10 relative overflow-hidden min-h-[260px]">
                    {/* Decorative rings */}
                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                      <div className="w-64 h-64 rounded-full border border-primary/10 absolute animate-ping" style={{ animationDuration: "4s" }} />
                      <div className="w-48 h-48 rounded-full border border-primary/15 absolute" />
                      <div className="w-32 h-32 rounded-full border border-primary/20 absolute" />
                    </div>
                    <div className="relative z-10 w-28 h-28 rounded-3xl bg-white shadow-2xl shadow-primary/20 flex items-center justify-center border border-primary/10">
                      <ActiveIcon className="w-14 h-14 text-primary" strokeWidth={1.2} />
                    </div>
                    {active.id === "hr" && (
                      <div className="absolute bottom-6 left-1/2 -translate-x-1/2">
                        <img 
                          src="https://static.wixstatic.com/media/a7119d_66f39e89757143bf988d13e7ac5976e9~mv2.png/v1/fill/w_257,h_117,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/house%20of%20trucking.png" 
                          alt="House of Trucking" 
                          className="h-10 object-contain opacity-60"
                        />
                      </div>
                    )}
                    {/* Step number watermark */}
                    <div className="absolute top-4 right-6 text-[80px] font-black text-primary/5 leading-none select-none pointer-events-none">
                      {String(displayService + 1).padStart(2, "0")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


        {/* Happy Customers Section */}
        <section className="py-24 bg-navy-950 text-white relative overflow-hidden">
          <div className="absolute inset-0 bg-[url('https://assets.cdn.filesafe.space/gUCbLLrJwD5vtwXYoPEZ/media/69f0ff9b40534248c5a223af.webp')] opacity-10 bg-cover bg-center"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/90 to-navy-950"></div>
          <div className="container mx-auto px-4 text-center relative z-10">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-16">{isRu ? "Присоединяйтесь к миллионам" : "Join over a million"} <span className="text-primary">{isRu ? "довольных клиентов!" : "happy customers!"}</span></h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
              {[
                { icon: ShieldCheck, title: isRu ? "Экспертиза" : "Expertise", desc: isRu ? "Многолетний опыт работы в отрасли гарантирует, что ваш груз находится в надежных и опытных руках" : "Years of industry experience ensure your cargo is in trusted, capable hands" },
                { icon: CheckCircle2, title: isRu ? "Гибкие условия" : "Flexible Terms", desc: isRu ? "Удобные для клиентов варианты, адаптированные к вашим конкретным потребностям и бюджету" : "Customer-friendly options tailored to meet your specific needs and budget" },
                { icon: Shield, title: isRu ? "Гарантия качества" : "Quality Assurance", desc: isRu ? "Первоклассный сервис с акцентом на безопасность, надежность и своевременную доставку" : "Top-notch service with a focus on safety, reliability, and timely delivery" }
              ].map((item, i) => (
                <div key={i} className="bg-white/5 border border-white/10 p-10 rounded-3xl backdrop-blur-sm hover:-translate-y-2 hover:bg-white/10 transition-all duration-300 group shadow-2xl">
                  <div className="w-16 h-16 rounded-2xl bg-primary/20 text-primary flex items-center justify-center mb-8 mx-auto group-hover:scale-110 group-hover:rotate-6 transition-transform duration-300">
                    <item.icon className="w-8 h-8" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">{item.title}</h3>
                  <p className="text-white/70 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Banners Section */}
        <section ref={sectionRef} className="py-24 bg-navy-950 relative overflow-hidden">
          <div className="container mx-auto px-4 max-w-6xl space-y-10">
            {getBannersData(isRu).map((banner, i) => (
              <div 
                key={i}
                className="relative rounded-[2.5rem] overflow-hidden min-h-[320px] md:min-h-[400px] group cursor-pointer shadow-2xl transition-all duration-500 hover:-translate-y-2 border border-white/5"
              >
                {/* Background Image with Parallax Effect */}
                <div className="absolute inset-0 z-0">
                  <img 
                    src={banner.img} 
                    alt={banner.title} 
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
                  />
                  {/* Gradient Overlay for Readability */}
                  <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent md:from-black/80 md:via-black/40"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 h-full flex flex-col md:flex-row items-start md:items-center justify-between p-8 md:p-16 gap-8">
                  <div className="max-w-xl">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/20 border border-primary/30 text-primary font-bold tracking-widest uppercase text-[10px] mb-6">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary animate-pulse"></span>
                      {banner.label}
                    </div>
                    <h3 className="text-4xl md:text-6xl font-black text-white tracking-tighter mb-4 leading-none">
                      {banner.title}
                    </h3>
                    <p className="text-white/70 text-lg md:text-xl font-medium max-w-md leading-relaxed">
                      {banner.desc}
                    </p>
                  </div>

                  <Link to={banner.link} className="shrink-0" aria-label={`${banner.btn} ${banner.title}`}>
                    <Button 
                      size="lg"
                      className={`group/btn relative overflow-hidden h-16 px-10 text-lg font-bold rounded-xl transition-all duration-300 ${
                        banner.title === "FUEL CARDS" 
                          ? "bg-primary text-white hover:bg-primary/90 shadow-[0_0_20px_rgba(59,130,246,0.5)]" 
                          : "bg-white text-navy-950 hover:bg-slate-100 shadow-xl"
                      }`}
                    >
                      <span className="relative z-10 flex items-center gap-2">
                        {banner.btn} <span className="sr-only"> {banner.title}</span>
                        <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </span>
                      {/* Button Shine Effect */}
                      <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white/10 opacity-40 group-hover/btn:animate-shine"></div>
                    </Button>
                  </Link>
                </div>

                {/* Mouse Follow Glow (CSS based) */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none bg-[radial-gradient(circle_at_var(--mouse-x,50%)_var(--mouse-y,50%),rgba(59,130,246,0.15)_0%,transparent_50%)]"></div>
              </div>
            ))}
          </div>
        </section>

        {/* Stats & Hand Image Section */}
        <section className="py-24 bg-white overflow-hidden border-t border-slate-100">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-[1920px] mx-auto">
            <div className="lg:w-1/2 relative group w-full flex justify-start overflow-hidden lg:overflow-visible">
              <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
              <img 
                src="https://static.wixstatic.com/media/5c8a3f_692872a1103a43c3b151fb190660505e~mv2.png/v1/fill/w_960,h_706,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/5c8a3f_692872a1103a43c3b151fb190660505e~mv2.png" 
                alt="AITIM Capital Card" 
                loading="lazy"
                className="w-full max-w-none lg:w-[110%] lg:-ml-12 drop-shadow-[0_20px_50px_rgba(0,0,0,0.15)] group-hover:-translate-y-4 group-hover:scale-105 transition-all duration-700 relative z-10"
              />
            </div>
            <div className="lg:w-1/2 px-4 lg:pr-12 xl:pr-24 w-full">
              <div className="max-w-xl mx-auto lg:mx-0">
                <div className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary font-bold text-xs mb-6 tracking-widest uppercase">
                  {isRu ? "Почему мы" : "Why Choose Us"}
                </div>
                <h2 className="text-5xl md:text-7xl font-black text-navy-950 mb-16 tracking-tight">AITIM GROUP</h2>
                
                <div className="grid grid-cols-2 gap-x-4 sm:gap-x-8 gap-y-8 sm:gap-y-12">
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-navy-950 mb-4 group-hover:scale-110 origin-left transition-transform duration-300">10+</div>
                    <div className="h-0.5 bg-navy-950 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-[10px] sm:text-sm font-medium tracking-widest text-navy-950 uppercase group-hover:text-primary transition-colors whitespace-pre-line">{isRu ? 'ЛЕТ ОПЫТА' : 'YEARS OF\nEXPERIENCE'}</div>
                  </div>
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-navy-950 mb-4 group-hover:scale-110 origin-left transition-transform duration-300">7000+</div>
                    <div className="h-0.5 bg-navy-950 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-[10px] sm:text-sm font-medium tracking-widest text-navy-950 uppercase group-hover:text-primary transition-colors whitespace-pre-line">{isRu ? 'ГРУЗОВИКОВ В СЕТИ' : 'TRUCKS IN OUR\nNETWORK'}</div>
                  </div>
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-navy-950 mb-4 group-hover:scale-110 origin-left transition-transform duration-300">100%</div>
                    <div className="h-0.5 bg-navy-950 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-[10px] sm:text-sm font-medium tracking-widest text-navy-950 uppercase group-hover:text-primary transition-colors whitespace-pre-line">{isRu ? 'УДОВЛЕТВОРЕННОСТЬ' : 'CUSTOMER\nSATISFACTION'}</div>
                  </div>
                  <div className="group">
                    <div className="text-4xl md:text-6xl font-light text-navy-950 mb-4 group-hover:scale-110 origin-left transition-transform duration-300">20+</div>
                    <div className="h-0.5 bg-navy-950 w-full mb-4 relative overflow-hidden">
                      <div className="absolute top-0 left-0 h-full bg-primary w-0 group-hover:w-full transition-all duration-500"></div>
                    </div>
                    <div className="text-[10px] sm:text-sm font-medium tracking-widest text-navy-950 uppercase group-hover:text-primary transition-colors whitespace-pre-line">{isRu ? 'НАГРАД И ПРИЗНАНИЙ' : 'AWARDS AND\nRECOGNITIONS'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </div>
  );
};

export default Trucking;
